import * as React from 'react';
import {Link} from 'react-router-dom';

import Tooltip from 'antd/lib/tooltip';

import '@app/scss/components/fiftyFifty.scss';
import GetInTouchButton from '@app/components/Forms/GetInTouch/GetInTouchButton';
import listenerForBrowser from '@app/components/Pages/listenerForBrowser';
import {tooltipDotLocation} from '@app/components/Pages/QualityOfLife/QualityOfLifeAssessment';

interface FiftyFiftyProps {
	title: string | JSX.Element;
	text: string;
	commonText?: string;
	src: string;
	alt?: string;
	btnText?: string;
	btnPath?: string;
	btnClick?: () => void | undefined;
	reversed?: boolean;
	openInNewTab?: any;
	name?: string;
	evaluation?: string | JSX.Element;
	subtitle?: string;
	dotScores?: [];
	useGetInTouchButton?: string | null;
}

const FiftyFiftyExtend: React.FC<FiftyFiftyProps> = (props) => {
	const [isMobile, setIsMobile] = React.useState(false);

	React.useEffect(() => {
		const mql = window.matchMedia('screen and (max-width: 768px)');

		const listenerFunc = () => {
			if (mql.matches) {
				setIsMobile(true);
			} else {
				setIsMobile(false);
			}
		};
		listenerFunc();
		listenerForBrowser(mql, listenerForBrowser);
	}, []);

	return (
		<section className={`fifty-fifty fifty-fifty_extend ${props.reversed ? 'fifty-fifty_reversed' : ''}`} id={props.name}>
			{isMobile &&
				<article className="qol-results-mobile">
					{
						props.subtitle ? <h6 className="fifty-fifty__subtitle">{props.subtitle}</h6> : null
					}
					<h2 className="fifty-fifty__title highlight">{props.title}</h2>
					<div className="fifty-fifty__subtitle">{props.evaluation}</div>

					<div className="text-center qol-results-mobile__inner">
						<div className={`qol-results-img-wrapper ${props.name}`}>
							<img className="fifty-fifty__img" src={props.src} alt={props.alt || ''}/>
							{props.dotScores &&
								Object.keys(props.dotScores).map((item) => {
									return (
										<Tooltip title={tooltipDotLocation[item] || ''} key={`qol-results-dot-${item}`}>
											<span className={`qol-results-dot qol-results-dot-${item} qol-results-dot-saturate-${props.dotScores?.[item]}`}/>
										</Tooltip>
									);
								})
							}
						</div>
					</div>

					{props.commonText && <p className="fifty-fifty-block_text">{props.commonText}</p>}
					<p className="fifty-fifty-block_text">{props.text}</p>

					{props.useGetInTouchButton &&
					<div className="fifty-fifty__btn">
						<a className="btn btn-sm btn-primary" href={'tel:(855) 933-5683'}>
							<span>Schedule a Telehospice Appointment</span>
						</a>
					</div>
					}

					{!props.useGetInTouchButton && props.btnClick &&
					<div className="fifty-fifty__btn">
						<a className="btn btn-primary" onClick={props.btnClick} target="_blank">{props.btnText}</a>
					</div>
					}
				</article>
			}
			{!isMobile &&
			<>
				<section className="fifty-fifty-block">
					{
						props.subtitle ? <h6 className="fifty-fifty__subtitle">{props.subtitle}</h6> : null
					}
					<h2 className="fifty-fifty__title highlight">{props.title}</h2>
					<div className="fifty-fifty__subtitle">{props.evaluation}</div>

					{props.commonText && <p className="fifty-fifty-block_text">{props.commonText}</p>}
					<p className="fifty-fifty-block_text">{props.text}</p>

					{props.useGetInTouchButton &&
					<div className="fifty-fifty__btn">
						<GetInTouchButton btnText="Schedule a Telehospice Appointment"/>
					</div>
					}

					{!props.useGetInTouchButton && props.btnClick &&
					<div className="fifty-fifty__btn">
						<a className="btn btn-primary" onClick={props.btnClick} target="_blank">{props.btnText}</a>
					</div>
					}

						{props.btnPath && props.btnText && (
							<div className="fifty-fifty__btn">
								<Link className="btn btn-primary" onClick={() => props.openInNewTab(props.btnPath)} to="/angel-fund" target="_blank">{props.btnText}</Link>
							</div>
						)}
					</section>
					<div className="fifty-fifty-block">
						<div className={`qol-results-img-wrapper ${props.name}`}>
							<img className="fifty-fifty__img" src={props.src} alt={props.alt || ''}/>
							{props.dotScores &&
								Object.keys(props.dotScores).map((item) => {
									return (
										<Tooltip title={tooltipDotLocation[item] || ''} key={`qol-results-dot-${item}`}>
											<span className={`qol-results-dot qol-results-dot-${item} qol-results-dot-saturate-${props.dotScores?.[item]}`}/>
										</Tooltip>
									);
								})
							}
						</div>
					</div>
				</>
			}
		</section>
	);
};

export default FiftyFiftyExtend;
